// Reveals text word by word (rise and fade). The whole sentence stays in the DOM once, for screen readers and tests;
// each visible word is a pseudo-element. Reduced motion: the words simply fade in together.
export function StaggerWords({ text, className = '', delayMs = 0, stepMs = 60 }: { text: string; className?: string; delayMs?: number; stepMs?: number }) {
  const words = text.split(/\s+/).filter(Boolean);
  return (
    <span className={className} key={text}>
      <span className="sr-only">{text}</span>
      <span aria-hidden="true">
        {words.map((w, i) => (
          <span key={`${i}-${w}`}>
            <span className="rd-word" data-word={w} style={{ animationDelay: `${delayMs + i * stepMs}ms` }} />
            {i < words.length - 1 ? ' ' : null}
          </span>
        ))}
      </span>
    </span>
  );
}
